import React from 'react';
import { moduleHost } from '../../infrastructure/components/root-module-host';
import { connectUsersVM, UsersContext } from './users.context';
import { UsersVM } from './users.viewmodel';
import UsersList from './_users-list/users-list';

interface IProps {
    vm: UsersVM;
}

const UsersContainer = ({ vm }: IProps) => <UsersList vm={vm} />;

const UsersConnected = connectUsersVM<IProps>(UsersContainer, vm => ({ vm: vm }));

export const Users = moduleHost(UsersVM, UsersContext, UsersConnected);
